import { useEffect, useState, useCallback } from 'react';
import { useAuth } from '@clerk/clerk-react';

const API_BASE = process.env.REACT_APP_API_URL;

export default function useOrgMembership() {
  const { getToken, isSignedIn } = useAuth();
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchOrg = useCallback(async () => {
    if (!isSignedIn) {
      setOrg(null);
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      const token = await getToken();
      const res = await fetch(`${API_BASE}/org/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error('Failed to fetch org');
      const data = await res.json();
      setOrg(data.org || null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [isSignedIn, getToken]);

  useEffect(() => {
    fetchOrg();
  }, [fetchOrg]);

  const joinOrg = useCallback(async (orgName) => {
    const token = await getToken();
    const res = await fetch(`${API_BASE}/org/join`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ orgName })
    });
    if (!res.ok) {
      const data = await res.json();
      throw new Error(data.error || 'Failed to join company');
    }
    const data = await res.json();
    setOrg(data.org);
    return data.org;
  }, [getToken]);

  return { org, loading, error, refetch: fetchOrg, joinOrg };
}
